<template>
  <div style="">
    <NavTop ref="nav" class="navbar"/>
    <div class="subdiv _subdiv">
      <div class="subdivimg _subdivimg">
        <Carousel5></Carousel5>
      </div>
    </div>
    <div class="homecontainer _homecontainer">
      <div class="box _box" style="" v-if="windowWidth>800">
        <div class="box-content _box-content">
          <div class="box-title _box-title">
            <div style="height: 100%;width: 0.2em;background-color: #00AEF0;display: inline-block;"></div>
            <div style="background: linear-gradient(to right, rgba(209,237,246,0.65), #ffffff);">
              <div style="margin-left: 0.5em;cursor: pointer" @click="openPage($t('home.lmleccNews'))">
                {{ $t('home.highlights') }}
              </div>
            </div>
          </div>
          <div class="box-line _box-line"></div>
          <div class="highlights-grid-container">
            <!-- 网格布局容器 -->
            <div class="highlights-grid">
              <div
                v-for="(item, index) in displayedHighlights"
                :key="index"
                class="highlight-card"
                @click="openCategoryPage(item, index)"
              >
                <div class="card-header">
                  <h3 class="card-title">{{ $t(item.categoryTitle) || item.categoryTitleFallback }}</h3>
                  <div class="card-divider"></div>
                </div>
                <div class="card-content">
                  <div class="card-image" :style="{ backgroundImage: `url(${item.Img})` }">
                  </div>
                  <div class="card-text">
                    <p class="card-description">{{ item.title }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box _box" style="" v-if="windowWidth<=800">
        <div class="box-content _box-content">
          <div class="box-title _box-title">
            <div style="height: 100%;width: 0.2em;background-color: #00AEF0;display: inline-block;"></div>
            <div style="background: linear-gradient(to right, rgba(209,237,246,0.65), #ffffff);">
              <div style="margin-left: 0.5em;cursor: pointer" @click="openPage($t('home.lmleccNews'))">
                {{ $t('home.highlights') }}
              </div>
            </div>
          </div>
          <div class="box-line _box-line"></div>
          <div class="highlights-grid-container mobile">
            <!-- 移动端网格布局容器 -->
            <div class="highlights-grid mobile">
              <div
                v-for="(item, index) in displayedHighlights"
                :key="index"
                class="highlight-card mobile"
                @click="openCategoryPage(item, index)"
              >
                <div class="card-header mobile">
                  <h3 class="card-title mobile">{{ $t(item.categoryTitle) || item.categoryTitleFallback }}</h3>
                  <div class="card-divider mobile"></div>
                </div>
                <div class="card-content mobile">
                  <div class="card-image mobile" :style="{ backgroundImage: `url(${item.Img})` }">
                  </div>
                  <div class="card-text mobile">
                    <p class="card-description mobile">{{ item.title }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 战略愿景 开始-->
      <div style="background: #F8F8F8;width: 100%">
        <div class="box _box" style="background: #F8F8F8;">
          <div class="box-content2 _box-content2" style="">
            <div class="box-title _box-title">
              <div style="height: 100%;width: 0.2em;background-color: #00AEF0;display: inline-block;"></div>
              <div style="background: linear-gradient(to right, #D1EDF6, #ffffff)">
                <div style="display: inline-block;margin-left: 0.5em;color: #0e1113;cursor: pointer"
                     @click="openRouter(3)">
                  {{ $t('home.strategicVision') }}
                </div>
              </div>
            </div>
            <div class="box-line _box-line"></div>

            <el-row style="width: 100%;height: 100%;margin-top: 20px;">
              <el-col :span="6" style="height: 100%;display: flex;justify-content: center;">
                <div class="vision-card1 _vision-card1" @click="openRouter(1)">
                  <div class="vision-card1-img _vision-card1-img"></div>
                  <div class="vision-footer _vision-footer">
                    <span>{{ $t('home.intelliegenceCenter') }}</span>
                  </div>
                </div>
              </el-col>
              <el-col :span="6" style="height: 100%;display: flex;justify-content: center;">
                <div class="vision-card2 _vision-card2" @click="openRouter(2)">
                  <div class="vision-card2-img _vision-card2-img"></div>
                  <div class="vision-footer _vision-footer">
                    <span>{{ $t('home.jointOperationCenter') }}</span>
                  </div>
                </div>
              </el-col>
              <el-col :span="6" style="height: 100%;display: flex;justify-content: center;">
                <div class="vision-card3 _vision-card3" @click="openRouter(3)">
                  <div class="vision-card3-img _vision-card3-img"></div>
                  <div class="vision-footer _vision-footer">
                    <span>{{ $t('home.LawEnforcementCapacityBuildingCenter') }}</span>
                  </div>
                </div>
              </el-col>
              <el-col :span="6" style="height: 100%;display: flex;justify-content: center;">
                <div class="vision-card4 _vision-card4" @click="openRouter(4)">
                  <div class="vision-card4-img _vision-card4-img"></div>
                  <div class="vision-footer _vision-footer">
                    <span>{{ $t('home.EmergencyResponseCenter') }}</span>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!-- 战略愿景 结束-->

      <!-- 澜湄区域执法动态信息地图 开始-->
      <div class="box _box" style="background-color: #FFFFFF;">
        <div :class="['box-content', '_box-content', windowWidth > 800 ? 'crime-map-content-pc' : 'crime-map-content-mobile']">
          <div class="box-title _box-title">
            <div style="height: 100%;width: 0.2em;background-color: #00AEF0;display: inline-block;"></div>
            <div style="background: linear-gradient(to right, rgba(209,237,246,0.65), #ffffff);">
              <div style="margin-left: 0.5em;">
                {{ $t('home.crimeMap') || '澜湄区域执法动态信息地图' }}
              </div>
            </div>
          </div>
          <div class="box-line _box-line"></div>

          <!-- Tableau 可视化容器 -->
          <div :class="windowWidth > 800 ? 'tableau-container-pc' : 'tableau-container-mobile'">
            <iframe
              :src="$i18n.locale=='zh'?'/static/yexy.html':'/static/yexy_en.html'"
              width="100%"
              height="100%"
              frameborder="0"
              scrolling="no"
              :class="windowWidth > 800 ? 'tableau-iframe-pc' : 'tableau-iframe-mobile'">
            </iframe>
          </div>
        </div>
      </div>
      <!-- 澜湄区域犯罪形势地图 结束-->

<!--      -->


      <!-- 通报 -->
<!--      <div class="box1 _box1">-->
<!--        <div class="box-content _box-content">-->
<!--          <div class="box-title _box-title" style="color: #333333">-->
<!--            <div style="height: 100%;width: 0.2em;background-color: #00AEF0;display: inline-block;"></div>-->
<!--            <div style="background: linear-gradient(to right, #D1EDF6, #ffffff)">-->
<!--              <div style="display: inline-block;margin-left: 0.5em;color: #0e1113">{{-->
<!--                  $t('home.lancangMenong')-->
<!--                }}-->
<!--              </div>-->
<!--            </div>-->
<!--            &lt;!&ndash; <div style="width: 100%;">-->
<!--              <div style="display: flex;height: 40px;line-height: 40px">-->
<!--                <div style="height: 100%;width: 0.2em;background-color: #00AEF0;display: inline-block;"></div>-->
<!--                <div style="background: linear-gradient(to right, #d1edf8, #ffffff)">-->
<!--                  <div style="display: inline-block;margin-left: 0.5em;">{{ $t('home.lancangMenong') }}</div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div> &ndash;&gt;-->

<!--          </div>-->
<!--          &lt;!&ndash; <div style="flex:1;height:0.1cm;border-bottom: 2px solid #CCCCCC;width: 100%;margin-top: 0.2cm"></div> &ndash;&gt;-->
<!--          <div class="box-line _box-line"></div>-->

<!--          <div style="height: 100%;width: 100%;">-->
<!--            <div class="box-row _box-row">-->
<!--              <div class="box-col _box-col">-->
<!--                <div style="" class="box-divide _box-divide">-->
<!--                  <div class="box-title2 _box-title2" @click="openList('1')">-->
<!--                    {{ $t('home.wantedPerson') }}-->
<!--                    &lt;!&ndash; <div style="flex:1;height:100%;border-bottom: 2px solid #CCCCCC;"></div> &ndash;&gt;-->
<!--                  </div>-->
<!--                  <div style="display: flex;height:100%;align-items: center;">-->
<!--                    <Carousel2_1 style="width: 100%;height: 100%" v-if="windowWidth>=800"></Carousel2_1>-->
<!--                    <Carousel2_2 style="width: 100%;height: 100%" v-if="windowWidth<800"></Carousel2_2>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="box-col _box-col">-->
<!--                <div style="" class="box-divide2 _box-divide2">-->
<!--                  <div class="box-title2 _box-title2" @click="openList('2')">-->
<!--                    {{ $t('home.missingPerson') }}-->
<!--                    &lt;!&ndash; <div style="flex:1;height:100%;border-bottom: 2px solid #CCCCCC;"></div> &ndash;&gt;-->
<!--                  </div>-->
<!--                  <div style="display: flex;height:100%;align-items: center;">-->
<!--                    <Carousel3_1 style="width: 100%;height: 100%" v-if="windowWidth>=800"></Carousel3_1>-->
<!--                    <Carousel3_2 style="width: 100%;height: 100%" v-if="windowWidth<800"></Carousel3_2>-->

<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      通报结束-->
      <div class="pulic _pulic">
        <div class="box-content _box-content">
          <div class="box-title _box-title">
            <div style="height: 100%;width: 0.2em;background-color: #00AEF0;display: inline-block;"></div>
            <div style="background: linear-gradient(to right, rgba(49,189,234,0.33),rgba(209,237,246,0.04))">
              <span style="margin-left: 0.5em;">{{ $t('home.publication') }}</span>
            </div>
          </div>
          <div class="box-line _box-line"></div>
          <div style="width:100%;height: 100%;margin-top: 1.8em;display: flex;align-items: center;">
            <div style="color: #3a8ee6;font-size: 22px;cursor: pointer" @click="$refs.Carousel6.next1()"><i
              class="el-icon-arrow-left"></i></div>
            <Carousel6 ref="Carousel6" style="width: 100%;height: 100%"></Carousel6>
            <div style="color: #3a8ee6;font-size: 22px;cursor: pointer" @click="$refs.Carousel6.next2()"><i
              class="el-icon-arrow-right"></i></div>
          </div>
        </div>


      </div>
      <!--      <div class="box _box" style="background-color: #FFFFFF;">-->
      <!--        <div class="box-content3 _box-content3" >-->
      <!--          <div class="box-title _box-title" style="color: #333333">-->
      <!--            <div style="height: 100%;width: 0.2em;background-color: #00AEF0;display: inline-block;"></div>-->
      <!--            <div style="background: linear-gradient(to right, #D1EDF6, #ffffff)">-->
      <!--              <span style="margin-left: 0.5em;">{{ $t('home.links') }}</span>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--          <div class="box-line _box-line"></div>-->
      <!--          <div class="box-carousel _box-carousel">-->
      <!--            <Carousel4_1 style="width: 100%;height: 100%" v-if="windowWidth>800"></Carousel4_1>-->
      <!--            <Carousel4_2 style="width: 100%;height: 100%" v-if="windowWidth<800"></Carousel4_2>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>

</template>

<script>
import GoodBriefInfo from './subcomponents/GoodBriefInfo'
import NavTop from "../comcomponents/NavTop2.vue";
import {getnewList, getcolumnsList, getplugList} from "../../api/resouces";

import Carousel4_1 from "../carousel/carousel_swiper4.vue";
import Carousel4_2 from "../carousel/swiper_link.vue";

import Carousel from "../carousel/swiper_publication.vue";
import Carousel2_1 from "../carousel/swiper_wantedPerson.vue";
import Carousel2_2 from "../carousel/swiper_wantedPerson_phone.vue";

import Carousel3_1 from "../carousel/swiper_missingPerson.vue";
import Carousel3_2 from "../carousel/swiper_missingPerson_phone.vue";

import Carousel5 from "../carousel/swiper_banner.vue";
import Carousel6 from "../carousel/swiper_public.vue";

import cookie from "js-cookie";
import {getNavTopTree} from "@/api/navtop";
import Swiper from 'swiper'

export default {
  name: '',
  components: {
    Carousel,
    NavTop,
    GoodBriefInfo,
    Carousel2_1,
    Carousel2_2,
    Carousel3_1,
    Carousel3_2,
    Carousel4_1,
    Carousel4_2,
    Carousel5,
    Carousel6
  },

  data() {
    return {

      publicationDataList: [{title: ""}],//出版物数据列表
      publicationActive: 0,//出版物当前出现的图片数据索引
      hotList: [
        {url: 'http://lm-lesc-center.org/upload/20240809/2024080909422965.jpg'},
        {url: 'http://lm-lesc-center.org/upload/20240717/2024071716455349.jpg'},
        {url: 'http://lm-lesc-center.org/upload/20240717/2024071711300157.jpg'},
      ],


      src: "/static/3D图片叠加2408 copy/index.html",
      src2: "/static/photoNotice/index.html",
      src3: "/static/photoNotice2/index.html",
      columnsList: [],
      linkList: [],

      param: {
        id: "",
        pid: ""
      },
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      // 热点关注展示的数据
      displayedHighlights: [],
    }
  },

  created() {
  },
  mounted() {
    getNavTopTree().then(res => {
      this.titleTree = res.data[0]
      // titleTree加载完成后初始化热点关注数据
      this.updateDisplayedHighlights()
    })
    this.$refs.nav.home()
    this.getCoumnlis();
    this.getLinkList()
    this.getPublicationList()
  },
  methods: {
    updateDisplayedHighlights() {
      // 更新热点关注网格显示数据
      const categories = [
        {key: 'lmleccNews', titleKey: 'home.lmleccNews', fallback: '中心动态',zhId:109,enId:103},
        {key: 'regionalNews', titleKey: 'home.regionalNews', fallback: '区域动态',zhId:110,enId:104},
        {key: 'memberStatesInternalAffairs', titleKey: 'home.memberStatesInternalAffairs', fallback: '执法动态',zhId:112,enId:106},
        {key: 'memberStatesCooperation', titleKey: 'home.memberStatesCooperation', fallback: '澜湄国家合作',zhId:111,enId:105},
        {key: 'LawEnforcementCapacityBuildingCenter', titleKey: 'home.LawEnforcementCapacityBuildingCenter', fallback: '执法能力建设',zhId:119,enId:124},
        {key: 'thinkTankDynamics', titleKey: 'home.thinkTankDynamics', fallback: '智库动态',zhId:36,enId:84}
      ];

      // 初始化显示数据，稍后异步加载真实内容
      this.displayedHighlights = categories.map((category, index) => ({
        title: '暂无内容',
        Img: '/static/img/default-news.jpg',
        categoryTitle: category.titleKey,
        categoryTitleFallback: category.fallback
      }));

      // 异步加载每个分类的真实内容
      this.loadCategoryContents(categories);
    },

    // 加载各分类的真实内容
    loadCategoryContents(categories) {
      categories.forEach((category, index) => {
        // 直接使用固定的ID加载内容
        this.loadCategoryLatestContent(category, index);
      });
    },



    // 加载分类的最新内容
    loadCategoryLatestContent(category, index) {
      // 根据语言选择对应的ID
      const isZh = this.$i18n.locale === 'zh';
      const classId = isZh ? category.zhId : category.enId;
      let lang = isZh ? "1" : "2";

      // 调用API获取该分类的最新内容
      getnewList({classId: classId, lang: lang, size: 1}).then(res => {
        if (res.data && res.data.length > 0) {
          const latestContent = res.data[0];

          // 更新对应分类的数据
          this.$set(this.displayedHighlights, index, {
            ...latestContent,
            Img: latestContent.Img ? latestContent.Img.replace(/\/upload/g, `${this.$urlFile}/upload`) : '/static/img/default-news.jpg',
            categoryTitle: category.titleKey,
            categoryTitleFallback: category.fallback,
            classId: classId, // 使用固定的分类ID
            columnPid: isZh ? '108' : '107' // 根据语言设置父级ID
          });
        }
      }).catch(err => {
        console.log('获取分类内容失败:', category.fallback, err);
      });
    },
    getPublicationList() {
      this.publicationDataList = []
      if (this.$i18n.locale == 'zh') {
        getnewList({classId: 33}).then((res) => {
          res.data.forEach((item) => {
            if (item.Img) {
              item.Img = item.Img.replace(/\/upload/g, `${this.$urlFile}/upload`);
              this.publicationDataList.push(item);
            }
          });
        })
      } else {
        getnewList({classId: 73}).then((res) => {
          res.data.forEach((item) => {
            if (item.Img) {
              item.Img = item.Img.replace(/\/upload/g, `${this.$urlFile}/upload`);
              this.publicationDataList.push(item);
            }
          });
          getnewList({classId: 74}).then((res) => {
            res.data.forEach((item) => {
              if (item.Img) {
                item.Img = item.Img.replace(/\/upload/g, `${this.$urlFile}/upload`);
                this.publicationDataList.push(item);
              }
            });
          });

        });
      }


    },
    getLinkList() {
      getplugList().then(res => {
        this.linkList = res.data;
      })
    },
    getPid(id) {
      this.titleTree.children.forEach((item, index) => {
        if (item.children != null && item.children.length > 0) {
          item.children.forEach((item2, index2) => {
            if (item2.data.id == id) {
              this.pid = item2.data.columnPid
            } else {
              if (item2.children != null) {
                item2.children.forEach((ite, ind) => {
                  if (ite.data.id == id) {
                    this.pid = ite.data.columnPid
                  }
                })
              }
            }
          })
        }

      });
    },
    openPages(info) {
      this.$router.push({
        path: '/navigation',
        query: {
          pid: info.columnPid,
          id: info.id,
        }
      })
    },
    openDetile(info) {
      this.getPid(info.classId)
      this.$router.push({
        path: '/detail',
        query: {
          pid: this.pid,
          id: info.classId,
          detailId: info.id,
        }
      })
    },
    openCategoryPage(item, index) {
      // 根据不同的分类索引跳转到对应的页面
      console.log('点击分类卡片:', item, index);
      console.log('当前语言:', this.$i18n.locale);

      // 如果有具体的新闻数据，跳转到详情页
      if (item.id && item.classId) {
        this.openDetile(item);
        return;
      }

      // 如果有columnPid数据，使用它进行跳转
      if (item.columnPid && item.classId) {
        this.$router.push({
          path: '/navigation',
          query: {
            pid: item.columnPid,
            id: item.classId
          }
        });
        return;
      }

      // 根据分类跳转到对应的列表页面
      let targetRoute = null;

      // 根据当前语言和分类索引确定跳转路由
      const isEnglish = this.$i18n.locale === 'en';

            // 使用固定的分类ID映射
      const categoryIds = [
        {zhId: 109, enId: 103}, // 中心动态
        {zhId: 110, enId: 104}, // 区域动态
        {zhId: 111, enId: 105}, // 执法动态
        {zhId: 112, enId: 106}, // 澜湄国家合作
        {zhId: 119, enId: 124}, // 执法能力建设
        {zhId: 36, enId: 84}    // 智库动态
      ];

      if (index >= 0 && index < categoryIds.length) {
        const categoryId = categoryIds[index];
        targetRoute = {
          path: '/navigation',
          query: {
            pid: isEnglish ? '107' : '108',
            id: isEnglish ? categoryId.enId.toString() : categoryId.zhId.toString()
          }
        };
      } else {
        console.warn('未知的分类索引:', index);
        return;
      }

      if (targetRoute) {
        console.log('跳转到:', targetRoute);
        this.$router.push(targetRoute);
      }
    },
    getCoumnlis() {
      let lang = "";
      let classPid = ""
      if (this.$i18n.locale == 'zh') {
        lang = "1";
        classPid = "108"
      } else {
        lang = "2";
        classPid = "107"
      }
      getcolumnsList({columnPid: classPid, cType: lang}).then(res => {
        if (res.data != null) {
          this.columnsList = res.data
        }
      })
    },


    linkClick(index) {
      if (index % 2 == 0) {
        window.location.href = 'https://www.interpol.int/How-we-work/Notices/Yellow-Notices/View-Yellow-Notices'
      } else {
        window.location.href = 'https://www.interpol.int/How-we-work/Notices/Red-Notices/View-Red-Notices'

      }
    },

    imgPreview() {
      const iframeWindow = document.getElementById('photoIframe1').contentWindow;
      // iframe.contentWindow.postMessage(message, '*');
      // const iframeWindow = window.frames[1]; // 获取iframe的window对象
      iframeWindow.postMessage(
        {
          code: 'preview',
          test: '我是点击vue页面按钮后过来的数据!',
        },
        '*'
      )
    },
    imgNext() {
      const iframeWindow = document.getElementById('photoIframe1').contentWindow;

      // const iframeWindow = window.frames[1]; // 获取iframe的window对象
      iframeWindow.postMessage(
        {
          code: 'next',
          test: '我是点击vue页面按钮后过来的数据!',
        },
        '*'
      )
    },
    imgPreview2() {
      const iframeWindow = document.getElementById('photoIframe2').contentWindow;
      // const iframeWindow = window.frames[2]; // 获取iframe的window对象
      iframeWindow.postMessage(
        {
          code: 'preview',
          test: '我是点击vue页面按钮后过来的数据!',
        },
        '*'
      )
    },
    imgNext2() {
      // const iframeWindow = window.frames[2]; // 获取iframe的window对象
      const iframeWindow = document.getElementById('photoIframe2').contentWindow;

      iframeWindow.postMessage(
        {
          code: 'next',
          test: '我是点击vue页面按钮后过来的数据!',
        },
        '*'
      )
    },
    imgPreview3() {
      const iframeWindow = document.getElementById('photoIframe3').contentWindow;

      // const iframeWindow = window.frames[3]; // 获取iframe的window对象
      iframeWindow.postMessage(
        {
          code: 'preview',
          test: '我是点击vue页面按钮后过来的数据!',
        },
        '*'
      )
    },
    publicationChange(index) {
      this.publicationActive = index
    },
    imgNext3() {
      // const iframeWindow = window.frames[3]; // 获取iframe的window对象
      const iframeWindow = document.getElementById('photoIframe3').contentWindow;
      iframeWindow.postMessage(
        {
          code: 'next',
          test: '我是点击vue页面按钮后过来的数据!',
        },
        '*'
      )
    },
    openRouter(index) {
      this.$router.push({
        path: '/strategic',
        query: {
          index: index

        }
      })
    },
    //红黄榜跳转
    openList(status) {
      // this.getPid(info.classId)
      this.$router.push({
        path: '/personNotice',
        query: {
          personStatus: status
        }
      })
    },
    openPage(title) {
      var that = this;
      this.param.pid = ""  //一级菜单id
      this.param.id = ""  //二级菜单id
      this.titleTree.children.forEach((item, index) => {
        if (item.title == title) {
          this.param.id = item.data.id
          this.param.pid = item.data.columnPid
        } else {
          if (item.children != null) {
            item.children.forEach((it, ind) => {
              if (it.title == title) {
                that.param.id = it.data.id
                that.param.pid = it.data.columnPid
              } else {
                if (it.children != null) {
                  it.children.forEach((its, inds) => {
                    if (its.title == title) {
                      that.param.id = its.data.id
                      that.param.pid = its.data.columnPid
                    }
                  })
                }
              }
            })
          }
        }
      });
      this.$router.push({
        path: '/navigation',
        query: {
          pid: this.param.pid,
          id: this.param.id,
          // isThirdLevel:false,
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
// @import "./css/imageflow.css";
// 大于800px
@media only screen and (min-width: 800px) {
  .navbar {
    position: sticky;
    top: 0; /* 距离顶部的距离 */
    background-color: #fff; /* 可选：根据需要设置背景颜色 */
    z-index: 1000; /* 确保导航栏在其他内容之上 */
  }

  .subdiv {
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    font-size: .5em;
    position: relative;
    align-items: center;
    justify-content: center;

    .subdivimg {
      // background-image: url(../../assets/home/home_back.png);
      width: 100%;
      height: 90vh;
      background-repeat: no-repeat;
      background-position: center; /* 可根据需求调整对齐方式 */
      // background-attachment: fixed;
      background-size: 100% 100%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;

    }

    .subdivtitle:hover {
      transform: scale(1.1);
    }

    .subdivtitle {
      display: flex;
      align-items: center;
      justify-content: center;
      //background-image: url(../../assets/home/homg_title2.png);
      width: 60%;
      height: 15vh;
      background-repeat: no-repeat;
      background-position: center; /* 可根据需求调整对齐方式 */
      // background-attachment: fixed;
      background-size: 100% 100%;
      transition: transform 0.3s ease;

      // border-radius:30px;
      // margin:0 auto;
    }

    .subdivweather {
      right: 5%;
      bottom: 20px;
      position: absolute;
    }

    .left {
      width: 48%;
      height: 100%;
      font-size: .8em;
    }

    .right {
      width: 48%;
      height: 100%;
      font-size: .8em;
    }
  }

  .imageflow {
    overflow: hidden;
    position: relative;
    text-align: left;
    visibility: hidden;
    width: 100%
  }

  .imageflow img {
    border: none;
    position: absolute;
    top: 0px;
    visibility: hidden;
    -ms-interpolation-mode: bicubic
  }

  .imageflow p {
    margin: 0 auto;
    text-align: center
  }

  .imageflow .loading {
    border: 1px solid #ccc;
    height: 15px;
    left: 50%;
    margin-left: -106px;
    padding: 5px;
    position: relative;
    visibility: visible;
    width: 200px
  }

  .imageflow .loading_bar {
    background: #ccc;
    height: 15px;
    visibility: visible;
    width: 1%
  }

  .imageflow .caption {
    font-weight: bold;
    position: relative;
    text-align: center;
    z-index: 10000
  }

  .imageflow .scrollbar {
    border-bottom: 1px solid #b3b3b3;
    position: relative;
    visibility: hidden;
    z-index: 10001;
    height: 1px
  }

  .imageflow .slider {
    height: 14px;
    margin: -6px 0 0 -7px;
    position: absolute;
    width: 14px;
    z-index: 10002
  }

  .imageflow .images {
    overflow: hidden;
    white-space: nowrap
  }

  .homecontainer {
    font-size: 1vw;
    width: 100%;
    //padding-left: 12%;
    //padding-right: 12%;
    margin: 0 auto;

    .subdiv {
      width: 100%;
      display: flex;
      justify-content: space-around;
      font-size: .5em;
      position: relative;
      align-items: center;
      justify-content: center;

      .subdivimg {
        background-image: url(../../assets/home/home_back.png);
        width: 100%;
        height: 80vh;
        background-repeat: no-repeat;
        background-position: center; /* 可根据需求调整对齐方式 */
        // background-attachment: fixed;
        background-size: 100% 100%;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;

      }

      .subdivtitle:hover {
        transform: scale(1.1);
      }

      .subdivtitle {
        background-image: url(../../assets/home/homg_title2.png);
        background-size: 100% 100%;
        width: 60%;
        height: 20vh;
        background-repeat: no-repeat;
        background-position: center; /* 可根据需求调整对齐方式 */
        // background-attachment: fixed;
        transition: transform 0.3s ease;
        // border-radius:30px;
        // margin:0 auto;
      }

      .subdivweather {
        right: 10px;
        bottom: 20px;
        position: absolute;
      }

      .left {
        width: 48%;
        height: 100%;
        font-size: .8em;
      }

      .right {
        width: 48%;
        height: 100%;
        font-size: .8em;
      }
    }

    .box {
      width: 100%;
      // height: 100vh;
      margin: 0 auto;
      background-color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;


      .box-content {
        width: 70%;
        height: 50em;
        //height: 85vh;
        //justify-content: center;
        //align-items: center;
        //border: 1px solid black;
        margin: 0 auto;
        /*padding-left: 3.5%;*/
        padding: 5% 0 2% 0;

        .box-title {
          width: 100%;
          height: 40px;
          font-family: "fzxbsjt";
          font-weight: bold;
          font-size: 28px;
          color: #333333;
          line-height: 40px;
          text-align: left;
          font-style: normal;
          display: flex;
        }

        .box-title2 {
          width: 100%;
          height: 40px;

          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: bold;
          font-size: 28px;
          color: #333333;
          line-height: 53px;
          text-align: center;
          font-style: normal;
          display: flex;
          justify-content: center;
        }

        .box-title2:hover {
          width: 100%;
          height: 40px;
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: bold;
          font-size: 28px;
          color: rgba(0, 174, 239, 1);
          line-height: 53px;
          text-align: center;
          font-style: normal;
          display: flex;
          justify-content: center;
          cursor: pointer;
        }

        .box-line {
          flex: 1;
          height: 0.1cm;
          border-bottom: 2px solid #CCCCCC;
          width: 100%;
          margin-top: 0.2cm
        }

        .box-carousel {
          width: 100%;
          height: 100%;
        }
      }

      .box-content2 {
        width: 70%;
        height: 35em;
        //height: 85vh;
        //justify-content: center;
        //align-items: center;
        //border: 1px solid black;
        margin: 0 auto;
        /*padding-left: 3.5%;*/
        padding: 5% 0 2% 0;

        .box-title {
          width: 100%;
          height: 40px;
          font-family: "fzxbsjt";
          font-weight: bold;
          font-size: 28px;
          color: #333333;
          line-height: 40px;
          text-align: left;
          font-style: normal;
          display: flex;
        }

        .box-title2 {
          width: 100%;
          height: 40px;

          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: bold;
          font-size: 28px;
          color: #333333;
          line-height: 53px;
          text-align: center;
          font-style: normal;
          display: flex;
          justify-content: center;
        }

        .box-title2:hover {
          width: 100%;
          height: 40px;
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: bold;
          font-size: 28px;
          color: rgba(0, 174, 239, 1);
          line-height: 53px;
          text-align: center;
          font-style: normal;
          display: flex;
          justify-content: center;
          cursor: pointer;
        }

        .box-line {
          flex: 1;
          height: 0.1cm;
          border-bottom: 2px solid #CCCCCC;
          width: 100%;
          margin-top: 0.2cm
        }

        .box-carousel {
          width: 100%;
          height: 100%;
        }
      }

      .box-content3 {
        width: 70%;
        height: 22em;
        //height: 85vh;
        //justify-content: center;
        //align-items: center;
        //border: 1px solid black;
        margin: 0 auto;
        /*padding-left: 3.5%;*/
        padding: 5% 0 2% 0;

        .box-title {
          width: 100%;
          height: 40px;
          font-family: "fzxbsjt";
          font-weight: bold;
          font-size: 28px;
          color: #333333;
          line-height: 40px;
          text-align: left;
          font-style: normal;
          display: flex;
        }

        .box-title2 {
          width: 100%;
          height: 40px;

          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: bold;
          font-size: 28px;
          color: #333333;
          line-height: 53px;
          text-align: center;
          font-style: normal;
          display: flex;
          justify-content: center;
        }

        .box-title2:hover {
          width: 100%;
          height: 40px;
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: bold;
          font-size: 28px;
          color: rgba(0, 174, 239, 1);
          line-height: 53px;
          text-align: center;
          font-style: normal;
          display: flex;
          justify-content: center;
          cursor: pointer;
        }

        .box-line {
          flex: 1;
          height: 0.1cm;
          border-bottom: 2px solid #CCCCCC;
          width: 100%;
          margin-top: 0.2cm
        }

        .box-carousel {
          width: 100%;
          height: 100%;
          margin-top: 2%
        }
      }
    }

    .box1 {
      width: 100%;
      height: 38em;
      margin: 0 auto;
      background-color: white;
      display: flex;
      align-items: center;
      justify-content: center;


      .box-content {
        width: 70%;
        height: 60%;
        //justify-content: center;
        //align-items: center;
        //border: 1px solid black;
        margin: 0 auto;
        margin-top: -5%;
        /*padding-left: 3.5%;*/


        .box-title {
          width: 100%;
          height: 40px;
          font-family: "fzxbsjt";
          font-weight: bold;
          font-size: 28px;
          color: #333333;
          line-height: 40px;
          text-align: left;
          font-style: normal;
          display: flex;
        }

        .box-title2 {
          width: 100%;
          height: 40px;
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: bold;
          font-size: 28px;
          color: #333333;
          line-height: 53px;
          text-align: center;
          font-style: normal;
          display: flex;
          justify-content: center;

        }

        .box-title2:hover {
          width: 100%;
          height: 40px;
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: bold;
          font-size: 28px;
          color: rgba(0, 174, 239, 1);
          line-height: 53px;
          text-align: center;
          font-style: normal;
          display: flex;
          justify-content: center;
          cursor: pointer;
        }

        .box-line {
          flex: 1;
          height: 0.1cm;
          border-bottom: 2px solid #CCCCCC;
          width: 100%;
          margin-top: 0.2cm
        }

        .box-row {
          height: 100%;
          width: 100%;
          margin-top: 3em;
        }

        .box-col {
          height: 100%;
          width: 50%;
          float: left;
        }

        .box-divide {
          width: 98%;
          height: 100%;
          border-right: 2px solid #CCCCCC;
          padding-right: 4%;
          cursor: pointer;
        }

        .box-divide2 {
          width: 98%;
          height: 100%;


        }
      }

    }

    .news-box {
      width: 100%;
      height: 88%;
      justify-content: center;
      justify-items: center;
      align-items: center;
      display: flex;
      margin-top: 2em;
    }

    .news-title {
      width: 22%;
      height: 90%;
      justify-content: center;

    }

    .news-title-box {
      height: 25%;
      // border:1px solid rgba(0, 0, 0, 0.15);
    }

    .news-title-box-active {
      background-color: rgba(0, 0, 0, 0.05);;
      text-align: center;
      height: 25%;
      box-shadow: -7px 7px 5px 1px rgba(0, 0, 0, 0.15);
      z-index: 99;
      // border:1px solid rgba(0, 0, 0, 0.15);
      // box-shadow:
      // -6px -6px 24px 0px rgba(0, 0, 0, 0.15);

      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }

    .news-title-item {
      height: 100%;
      font-size: 21px;
      font-weight: bold;
      width: 85%;
      text-align: center;
      line-height: 30px;
      // margin: 3% 0;
      cursor: pointer;
      border-bottom: 1px solid #b3b3b3;
      align-items: center;
      display: flex;
      justify-content: center;
    }

    .news-title-item-active {
      height: 100%;
      // height: 30px;
      font-size: 21px;
      font-weight: bold;
      width: 85%;
      text-align: center;
      line-height: 30px;
      // margin: 3% 0;
      cursor: pointer;
      // background-color: #E6E7E9;
      // border-bottom: 1px solid #b3b3b3;
      color: rgba(0, 174, 239, 1);
      align-items: center;
      display: flex;
      justify-content: center;

    }

    .news-title-item-next-active {
      height: 100%;
      // height: 30px;
      font-size: 21px;
      font-weight: bold;
      width: 85%;
      text-align: center;
      line-height: 30px;
      // margin: 3% 0;
      cursor: pointer;
      // background-color: #E6E7E9;
      // border-bottom: 1px solid #b3b3b3;
      // color: rgba(0, 174, 239, 1);
      align-items: center;
      display: flex;
      justify-content: center;

    }

    .news-title-item:hover {
      // height: 30px;
      width: 80%;
      // background-color: #E6E7E9;
      color: rgba(0, 174, 239, 1);

    }

    .news-title-item-line {
      height: 1px;
      width: 70%;
      background-color: #333333;

    }

    .news-content-box {
      width: 78%;
      height: 90%;
      // box-shadow: 0px 6px 24px 0px rgba(0, 0, 0, 0.15);
      background-color: rgba(0, 0, 0, 0.05);
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      box-shadow: 7px 7px 5px 1px rgba(0, 0, 0, 0.15);
      z-index: 1;

    }

    .news-content {
      width: 100%;
      height: 100%;
      padding: 1em 1em;
      // width: 78%;
      // height: 90%;
      // background-color: #E6E7E9;
      // border-radius: 40px;
      display: flex;
      justify-items: center;
      align-items: center;

    }

    /* 默认隐藏切换按钮 */

    .swiper-button-next {
      opacity: 0.3;
      background-image: url('../../assets/img/圆形箭头右.png');
      background-size: cover;
      height: 2.7em;
      width: 2.7em;
    }

    .swiper-button-prev {
      opacity: 0.3;
      background-image: url('../../assets/img/圆形箭头左.png');
      background-size: cover;
      height: 2.7em;
      width: 2.7em;
    }

    /* 默认隐藏切换按钮 */

    .swiper-button-next:hover,
    .swiper-button-prev:hover {
      opacity: 0.8;
    }

    /*.news-content:hover{*/
    /*  animation: pulse; !* referring directly to the animation's @keyframe declaration *!*/
    /*  animation-duration: 1s;*/
    /*}*/

    .news-content-left {
      width: 25%;
      height: 80%;
      align-items: center;
      margin-left: 2%;
      margin-right: 1%;
      position: relative;
      align-items: center;
    }

    .news-content-subtitle {
      width: 96%;
      /*height: 40px;*/

      font-weight: bold;
      font-size: 13px;
      white-space: nowrap; /* 确保文本不换行 */
      overflow: hidden; /* 隐藏超出容器的内容 */
      text-overflow: ellipsis; /* 使用省略号显示被截断的文本 */
    }

    .news-content-title {
      width: 100%;
      height: 80%;
      margin-top: 0.5em;
      text-align: left;
      line-height: 1.2em;
      display: flex;
      justify-items: center;
      font-size: 1.5em;

    }

    .news-content-span {
      width: 100%;
      height: 90%;
      font-weight: bold;
      overflow: hidden; /* 隐藏超出部分 */
      text-overflow: ellipsis; /* 以省略号显示被隐藏文本 */
      display: -webkit-box;
      -webkit-line-clamp: 7; /* 限制显示的行数 */
      line-clamp: 7; /* 标准属性 */
      -webkit-box-orient: vertical;
    }

    .news-content-datetime {
      font-size: 14px;
      position: absolute;
      bottom: 0;
      left: 0;
    }

    .news-content-right {
      width: 73%;
      height: 120%;
      align-items: center;
      display: flex;
    }

    .news-content-img {
      width: 90%;
      height: 100%;
      display: flex;
      overflow: hidden;
      border-radius: 40px;
    }

    .news-content-arrow-box {
      width: 10%;
      height: 100px;
      align-items: center;
      display: flex;
    }

    .news-content-arrow {
      width: 0;
      height: 0;
      border-top: 2em solid transparent;
      border-right: 2em solid transparent;
      border-bottom: 2em solid transparent;
      border-left: 2em solid #333333;
      margin-left: 1em;
      cursor: pointer;
    }

    .news-content-arrow-box2 {
      width: 10%;
      height: 100px;
      align-items: center;
      display: flex;
      margin-right: 100px;
    }

    .news-content-arrow2 {
      width: 0;
      height: 0;
      border-top: 2em solid transparent;
      border-left: 2em solid transparent;
      border-bottom: 2em solid transparent;
      border-right: 2em solid #333333;
      margin-left: 1em;
      cursor: pointer;
    }
  }

  .top {
    width: 100%;
    height: 8em;
  }

  .v-enter-from {
    transform: translateX(100%);
    opacity: 0;
  }

  .zlyj {
    width: 70%;
    height: 90vh;
    background: #F8F8F8;


    .box-content {
      margin: 0 auto;
      width: 100%;
    }

    .box-title {
      width: 100%;
      height: 40px;
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: bold;
      font-size: 28px;
      color: #ffffff;
      line-height: 40px;
      text-align: left;
      font-style: normal;
      display: flex;
    }
  }

  .pulic {
    width: 100%;
    // height: 75vh;
    background-color: #EBEBEB;
    // background-image: url(../../assets/img/黑底.png);
    background-size: 100% 100%;

    .box-content {
      margin: 0 auto;
      width: 70%;
      height: 40em;
      padding: 5% 0 10% 0;
    }

    .box-title {
      width: 100%;
      height: 40px;
      font-family: "fzxbsjt";
      font-weight: bold;
      font-size: 28px;
      // color: #ffffff;
      line-height: 40px;
      text-align: left;
      font-style: normal;
      display: flex;
    }

    .box-line {
      flex: 1;
      height: 0.1cm;
      border-bottom: 2px solid #CCCCCC;
      width: 100%;
      margin-top: 0.2cm
    }

    .box-carousel {
      height: 50vh;
    }

    /deep/ .el-carousel__container {
      height: 50vh;
    }

    .zoomable-background {
      background-position: center;
      transition: transform 0.5s ease; /* 平滑放大效果 */
      cursor: pointer; /* 将鼠标指针改为手指形状 */
      width: 35.35vh;
      height: 100%;
      background-size: 100% 100%;
      margin: 0 auto
    }

    .zoomable-background:hover {
      transform: scale(1.1); /* 鼠标悬停时放大1.1倍 */
    }
  }

  // .v-enter-active,
  // .v-leave-active {
  //     transition: transform 600ms ease-in-out, opacity 600ms ease-in-out;
  // }
  // .v-enter-to {
  //     transform: translateX(0);
  //     opacity: 1;
  // }
  // .v-leave-from {
  //     transform: translateX(0);
  //     opacity: 1;
  // }
  // .v-leave-to {
  //     transform: translateX(-100%);
  //     opacity: 0;
  // }\
  .swiper_title {
    text-align: center;
    width: 95%;
    padding-left: 1em;
    color: rgba(51, 51, 51, 1);
    font-size: 2.6vh;
    font-family: "fzxbsjt";
    font-weight: 500;
    text-overflow: ellipsis;

    /*white-space: nowrap; /* 确保文本不换行 */
    /*overflow: hidden; /* 隐藏超出容器的内容 */
    /*text-overflow: ellipsis; /* 使用省略号显示被截断的文本 */
    line-height: 1.4em;
  }

  .vision-card1 {
    position: relative;
    width: 16em;
    height: 70%;
    border-radius: 40px;
    //background-color: #FFFFFF;
    padding-top: 20%;
    //border: 3px solid #333333;
    cursor: pointer;
    /* border-radius: 50%; */
    /* background: url(./imgs/img_01.png) 100% no-repeat; */
    /* background-size: 100% 100%; */
  }

  .vision-card1-img {
    width: 20vh;
    height: 20vh;
    margin: 10% auto;
    /* border-radius: 50%; */
    /*background: url(./imgs/img_01.png) 100% no-repeat;*/
    background: url(../../assets/home/version3.png) 100% no-repeat;
    background-size: 100% 100%;
  }

  /* .vision-card1:hover {
    background: url(../../assets/home/情报hover.png) 100% no-repeat;
    background-size: 100% 100%;
  } */
  .vision-card2 {
    position: relative;
    width: 16em;
    height: 70%;
    border-radius: 40px;
    //background-color: #FFFFFF;
    padding-top: 20%;
    //border: 3px solid #333333;
    cursor: pointer;
    /* border-radius: 50%; */
    /* background: url(./imgs/img_01.png) 100% no-repeat; */
    /* background-size: 100% 100%; */
  }

  .vision-card2-img {
    width: 20vh;
    height: 20vh;
    margin: 10% auto;
    /* border-radius: 50%; */
    background: url(../../assets/home/version9.png) 100% no-repeat;
    /*background: url(./imgs/img_02.png) 100% no-repeat;*/
    background-size: 100% 100%;
  }


  .vision-card3 {
    position: relative;
    width: 16em;
    height: 70%;
    border-radius: 40px;
    //background-color: #FFFFFF;
    padding-top: 20%;
    //border: 3px solid #333333;
    cursor: pointer;
    /* border-radius: 50%; */
    /* background: url(./imgs/img_01.png) 100% no-repeat; */
    /* background-size: 100% 100%; */
  }

  .vision-card3-img {
    width: 20vh;
    height: 20vh;
    margin: 10% auto;
    /* border-radius: 50%; */
    /*background: url(./imgs/img_03.png) 100% no-repeat;*/
    background: url(../../assets/home/version7.png) 100% no-repeat;
    background-size: 100% 100%;
  }

  .vision-card4 {
    position: relative;
    width: 16em;
    height: 70%;
    border-radius: 40px;
    //background-color: #FFFFFF;
    padding-top: 20%;
    //border: 3px solid #333333;
    cursor: pointer;
    /* border-radius: 50%; */
    /* background: url(./imgs/img_01.png) 100% no-repeat; */
    /* background-size: 100% 100%; */
  }

  .vision-card1-img:hover {
    background: url(../../assets/img/鼠标经过有投影.png) 100% no-repeat;
    background-size: 100% 100%;
  }

  .vision-card2-img:hover {
    background: url(../../assets/img/编组2.png) 100% no-repeat;
    background-size: 100% 100%;
  }

  .vision-card3-img:hover {
    background: url(../../assets/img/编组8.png) 100% no-repeat;
    background-size: 100% 100%;
  }

  .vision-card4-img:hover {
    background: url(../../assets/img/编组.png) 100% no-repeat;
    background-size: 100% 100%;
  }

  .vision-card1:hover {
    color: #3a8ee6;
    animation: pulse; /* referring directly to the animation's @keyframe declaration */
    animation-duration: 1s;
  }

  .vision-card2:hover {
    color: #e6823a;
    animation: pulse; /* referring directly to the animation's @keyframe declaration */
    animation-duration: 1s;
  }

  .vision-card3:hover {
    color: #e65a3a;
    animation: pulse; /* referring directly to the animation's @keyframe declaration */
    animation-duration: 1s;
  }

  .vision-card4:hover {
    color: #08b22a;
    animation: pulse; /* referring directly to the animation's @keyframe declaration */
    animation-duration: 1s;
  }

  .vision-card4-img {
    width: 20vh;
    height: 20vh;
    margin: 10% auto;
    /* border-radius: 50%; */
    background: url(../../assets/home/version8.png) 100% no-repeat;
    /*background: url(./imgs/img_04.png) 100% no-repeat;*/
    background-size: 100% 100%;
  }

  /* .vision-card4 {
    position: relative;
    width: 16em;
    height: 16em;
    background-color: #FFFFFF;
    border-radius: 50%;
    overflow: hidden;
    background: url(../../assets/home/应急.png) 100% no-repeat;
    background-size: 100% 100%;
  } */
  /* .vision-card4:hover {
    background: url(../../assets/home/应急hover.png) 100% no-repeat;
    background-size: 100% 100%;
  } */
  .vision-footer {
    position: absolute;
    //bottom: 0;
    width: 100%;
    /* 调整高度以适合圆形底部，这里可能需要实验以找到最佳值 */
    height: calc(16em * 0.3); /* 假设你希望高度是圆直径的20% */
    border-radius: 0 0 50% 50%; /* 尝试给底部添加圆角以匹配圆形 */
    display: flex; /* 使用flex布局可以更容易地处理内容 */
    //align-items: center; /* 垂直居中内容 */
    justify-content: center; /* 水平居中内容 */
    font-size: 2vh;
    font-weight: bold;
    font-family: SourceHanSansCN, SourceHanSansCN;
    transition: opacity 0.3s ease; /* 添加过渡效果 */
    opacity: 1; /* 默认显示 */
  }

  .vision-card1:hover .vision-footer {
    //opacity: 0; /* 鼠标悬浮时隐藏 */
  }

  .vision-card2:hover .vision-footer {
    //opacity: 0; /* 鼠标悬浮时隐藏 */
  }

  .vision-card3:hover .vision-footer {
    //opacity: 0; /* 鼠标悬浮时隐藏 */
  }

  .vision-card4:hover .vision-footer {
    //opacity: 0; /* 鼠标悬浮时隐藏 */
  }

  .vision-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(153, 153, 153, 0); /* 初始时完全透明 */
    color: transparent; /* 初始时文本颜色也透明（但这通常不会影响显示，因为文本本身会占据空间） */
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 20px;
    transition: background-color 0.3s ease, color 0.3s ease; /* 添加过渡效果到颜色和背景 */
    pointer-events: none; /* 防止覆盖层干扰下方的点击事件（如果需要的话） */
    border-radius: 30px;
  }

  .vision-card1:hover .vision-overlay {
    //background-color: rgba(2, 189, 249, 0.45); /* 鼠标悬浮时显示 */
    /*background-color: rgba(249, 4, 4, 0.45); !* 鼠标悬浮时显示 *!*/
    //color: #FFFFFF; /* 鼠标悬浮时显示文本颜色 */
  }

  .vision-card2:hover .vision-overlay {
    //background-color: rgba(207, 124, 37, 0.45); /* 鼠标悬浮时显示 */
    //color: #FFFFFF; /* 鼠标悬浮时显示文本颜色 */
  }

  .vision-card3:hover .vision-overlay {
    //background-color: rgba(23, 234, 155, 0.45); /* 鼠标悬浮时显示 */
    //color: #FFFFFF; /* 鼠标悬浮时显示文本颜色 */
  }

  .vision-card4:hover .vision-overlay {
    //background-color: rgba(65, 161, 210, 0.45); /* 鼠标悬浮时显示 */
    //color: #FFFFFF; /* 鼠标悬浮时显示文本颜色 */
  }

  .publication-box {
    height: 50vh;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .publication_text {
    width: 100%;
    height: 90%;
    position: relative;
    // color: #fffefe;
  }

  .publication_title {
    //min-height: 2em;
    //overflow-wrap: break-word;
    // color: rgba(255, 255, 255, 1);
    font-size: 1.8em;
    font-family: "fzxbsjt";
    font-weight: 500;
    text-align: justify;
    //line-height: 1.2em;
    //padding: 0.5em 0;
  }

  .publication_content {
    min-height: 30%;
    overflow-wrap: break-word;
    // color: rgba(255, 255, 255, 1);
    font-size: 1em;
    font-family: ABCMarfa-Medium;
    font-weight: 400;
    text-align: left;
    line-height: 1.3em;
    padding: 0.6em 0;

  }

  .publication_date {
    width: 100%;
    text-align: right;
    // color: rgba(255, 255, 255, 1);
    font-size: 1em;
    padding-top: 0.6em

  }

  .publication_button {
    position: absolute;
    right: 0;
    bottom: 18%;

  }
}

// 小于800px
@media only screen and (max-width: 800px) {
  ._subdiv {
    width: 98%;
    margin: 1% auto;
    display: flex;
    justify-content: space-around;
    font-size: .5em;
    position: relative;
    align-items: center;
    justify-content: center;

    ._subdivimg {
      // background-image: url(../../assets/home/home_back.png);
      width: 98%;
      height: 40vw;
      background-repeat: no-repeat;
      background-position: center; /* 可根据需求调整对齐方式 */
      // background-attachment: fixed;
      background-size: 100% 100%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;

    }

    ._subdivtitle:hover {
      transform: scale(1.1);
    }

    ._subdivtitle {
      display: flex;
      align-items: center;
      justify-content: center;
      //background-image: url(../../assets/home/homg_title2.png);
      width: 60%;
      height: 15vh;
      background-repeat: no-repeat;
      background-position: center; /* 可根据需求调整对齐方式 */
      // background-attachment: fixed;
      background-size: 100% 100%;
      transition: transform 0.3s ease;

      // border-radius:30px;
      // margin:0 auto;
    }

    ._subdivweather {
      right: 5%;
      bottom: 20px;
      position: absolute;
    }

    .left {
      width: 48%;
      height: 100%;
      font-size: .8em;
    }

    .right {
      width: 48%;
      height: 100%;
      font-size: .8em;
    }
  }

  ._homecontainer {
    font-size: 1vw;
    // ._subdiv {
    //   width: 100%;
    //   display: flex;
    //   flex-direction: column;
    //   // justify-content: space-around;
    //   font-size: .5em;

    //   .left {
    //     width: 100%;
    //     height: 100%;
    //     font-size: .8em;
    //   }

    //   .right {
    //     width: 100%;
    //     height: 100%;
    //     font-size: .8em;
    //   }
    //   ._subdivimg {
    //   // background-image: url(../../assets/home/home_back.png);
    //   width: 98%;
    //   height: 80vh;
    //   background-repeat: no-repeat;
    //   background-position: center; /* 可根据需求调整对齐方式 */
    //   // background-attachment: fixed;
    //   background-size: 100% 100%;
    //   border-radius: 30px;
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;

    // }
    // }
    ._subdiv {
      width: 98%;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      font-size: .5em;
      position: relative;
      align-items: center;
      justify-content: center;

      ._subdivimg {
        // background-image: url(../../assets/home/home_back.png);
        width: 98%;
        height: 80vh;
        background-repeat: no-repeat;
        background-position: center; /* 可根据需求调整对齐方式 */
        // background-attachment: fixed;
        background-size: 100% 100%;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;

      }

      ._subdivtitle:hover {
        transform: scale(1.1);
      }

      ._subdivtitle {
        display: flex;
        align-items: center;
        justify-content: center;
        //background-image: url(../../assets/home/homg_title2.png);
        width: 60%;
        height: 15vh;
        background-repeat: no-repeat;
        background-position: center; /* 可根据需求调整对齐方式 */
        // background-attachment: fixed;
        background-size: 100% 100%;
        transition: transform 0.3s ease;

        // border-radius:30px;
        // margin:0 auto;
      }

      ._subdivweather {
        right: 5%;
        bottom: 20px;
        position: absolute;
      }

      .left {
        width: 48%;
        height: 100%;
        font-size: .8em;
      }

      .right {
        width: 48%;
        height: 100%;
        font-size: .8em;
      }
    }
  }

  ._box {
    width: 100%;
    // height: 100vh;
    margin: 0 auto;
    background-color: #FFFFFF;
    display: flex;
    align-items: stretch;
    justify-content: center;


    ._box-content {
      width: 90%;
      min-height: 0;
      height: auto;
      //height: 85vh;
      //justify-content: center;
      //align-items: center;
      //border: 1px solid black;
      margin: 5% auto;
      /*padding-left: 3.5%;*/
      padding: 0% 0;

      ._box-title {
        width: 100%;
        height: 40px;
        font-family: "fzxbsjt";
        font-weight: bold;
        font-size: 18px;
        color: #333333;
        line-height: 40px;
        text-align: left;
        font-style: normal;
        display: flex;
      }

      ._box-title2 {
        width: 100%;
        height: 40px;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: bold;
        font-size: 1.2vh;
        color: #333333;
        line-height: 53px;
        text-align: center;
        font-style: normal;
        display: flex;
        justify-content: center;
      }

      ._box-title2:hover {
        width: 100%;
        height: 40px;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: bold;
        font-size: 28px;
        color: rgba(0, 174, 239, 1);
        line-height: 53px;
        text-align: center;
        font-style: normal;
        display: flex;
        justify-content: center;
        cursor: pointer;
      }

      ._box-line {
        flex: 1;
        height: 0.05cm;
        border-bottom: 1px solid #CCCCCC;
        width: 100%;
        margin-top: 0.2cm
      }

      ._box-carousel {
        width: 100%;
        height: 50%;
        margin: 0 auto;
      }
    }

    ._box-content2 {
      width: 90%;
      min-height: 0;
      height: auto;
      //height: 85vh;
      //justify-content: center;
      //align-items: center;
      //border: 1px solid black;
      margin: 5% auto;
      /*padding-left: 3.5%;*/
      padding: 0% 0;

      ._box-title {
        width: 100%;
        height: 40px;
        font-family: "fzxbsjt";
        font-weight: bold;
        font-size: 18px;
        color: #333333;
        line-height: 40px;
        text-align: left;
        font-style: normal;
        display: flex;
      }

      ._box-title2 {
        width: 100%;
        height: 40px;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: bold;
        font-size: 1.2vh;
        color: #333333;
        line-height: 53px;
        text-align: center;
        font-style: normal;
        display: flex;
        justify-content: center;
      }

      ._box-title2:hover {
        width: 100%;
        height: 40px;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: bold;
        font-size: 28px;
        color: rgba(0, 174, 239, 1);
        line-height: 53px;
        text-align: center;
        font-style: normal;
        display: flex;
        justify-content: center;
        cursor: pointer;
      }

      ._box-line {
        flex: 1;
        height: 0.05cm;
        border-bottom: 1px solid #CCCCCC;
        width: 100%;
        margin-top: 0.2cm
      }

      ._box-carousel {
        width: 80%;
        height: 100%;
        margin: 0 auto;
      }
    }

    ._box-content3 {
      width: 90%;
      min-height: 0;
      height: auto;
      //height: 85vh;
      //justify-content: center;
      //align-items: center;
      //border: 1px solid black;
      margin: 5% auto;
      /*padding-left: 3.5%;*/
      padding: 0% 0;

      ._box-title {
        width: 100%;
        height: 40px;
        font-family: "fzxbsjt";
        font-weight: bold;
        font-size: 18px;
        color: #333333;
        line-height: 40px;
        text-align: left;
        font-style: normal;
        display: flex;
      }

      ._box-title2 {
        width: 100%;
        height: 40px;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: bold;
        font-size: 1.2vh;
        color: #333333;
        line-height: 53px;
        text-align: center;
        font-style: normal;
        display: flex;
        justify-content: center;
      }

      ._box-title2:hover {
        width: 100%;
        height: 40px;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: bold;
        font-size: 28px;
        color: rgba(0, 174, 239, 1);
        line-height: 53px;
        text-align: center;
        font-style: normal;
        display: flex;
        justify-content: center;
        cursor: pointer;
      }

      ._box-line {
        flex: 1;
        height: 0.05cm;
        border-bottom: 1px solid #CCCCCC;
        width: 100%;
        margin-top: 0.2cm
      }

      ._box-carousel {
        width: 80%;
        height: 100%;
        margin: 0 auto;
      }
    }
  }

  ._news-box {
    width: 100%;
    height: 75%;
    justify-content: center;
    justify-items: center;
    align-items: center;
    display: flex;
    margin-top: 2em;
  }

  ._news-title {
    width: 22%;
    height: 90%;
    justify-content: center;
  }

  ._news-title-box {
    height: 25%;
    // border:1px solid rgba(0, 0, 0, 0.15);
  }

  ._news-title-box-active {
    background-color: rgba(0, 0, 0, 0.05);;
    text-align: center;
    height: 25%;
    box-shadow: -5px 5px 3px 1px rgba(0, 0, 0, 0.15);
    z-index: 99;
    // border:1px solid rgba(0, 0, 0, 0.15);
    // box-shadow:
    // -6px -6px 24px 0px rgba(0, 0, 0, 0.15);

    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  ._news-title-item {
    height: 100%;
    font-size: 11px;
    font-weight: bold;
    width: 85%;
    text-align: center;
    line-height: 20px;
    // margin: 3% 0;
    cursor: pointer;
    border-bottom: 0.8px solid #b3b3b3;
    align-items: center;
    display: flex;
    justify-content: center;
  }

  ._news-title-item-active {
    height: 100%;
    // height: 30px;
    font-size: 11px;
    font-weight: bold;
    width: 85%;
    text-align: center;
    line-height: 20px;
    // margin: 3% 0;
    cursor: pointer;
    // background-color: #E6E7E9;
    // border-bottom: 1px solid #b3b3b3;
    color: rgba(0, 174, 239, 1);
    align-items: center;
    display: flex;
    justify-content: center;

  }

  ._news-title-item-next-active {
    height: 100%;
    // height: 30px;
    font-size: 11px;
    font-weight: bold;
    width: 85%;
    text-align: center;
    line-height: 20px;
    // margin: 3% 0;
    cursor: pointer;
    // background-color: #E6E7E9;
    // border-bottom: 1px solid #b3b3b3;
    // color: rgba(0, 174, 239, 1);
    align-items: center;
    display: flex;
    justify-content: center;

  }

  .news-content-box {
    width: 78%;
    height: 90%;
    // box-shadow: 0px 6px 24px 0px rgba(0, 0, 0, 0.15);
    background-color: rgba(0, 0, 0, 0.05);
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    box-shadow: 5px 5px 3px 1px rgba(0, 0, 0, 0.15);
    z-index: 1;

  }

  ._news-content {
    width: 100%;
    height: 100%;
    padding: 1.5em 1.5em;
    // background-color: #E6E7E9;
    // border-radius: 40px;
    display: flex;
    justify-items: center;
    align-items: center;
  }

  /* 默认隐藏切换按钮 */
  ._swiper-button-next {
    opacity: 0.8;
    background-image: url('../../assets/img/圆形箭头右.png');
    background-size: cover;
    height: 8em;
    width: 8em;
  }

  ._swiper-button-prev {
    opacity: 0.8;
    background-image: url('../../assets/img/圆形箭头左.png');
    background-size: cover;
    height: 8em;
    width: 8em;
  }

  /* 默认隐藏切换按钮 */
  ._swiper-button-next:hover,
  ._swiper-button-prev:hover {
    opacity: 0.8;
  }

  ._swiper_title {
    text-align: center;
    width: 95%;
    padding-left: 1em;
    color: rgba(51, 51, 51, 1);
    font-size: 8px;
    font-family: "fzxbsjt";
    font-weight: 500;
    text-overflow: ellipsis;

    /*white-space: nowrap; /* 确保文本不换行 */
    /*overflow: hidden; /* 隐藏超出容器的内容 */
    /*text-overflow: ellipsis; /* 使用省略号显示被截断的文本 */
    line-height: 1.4em;
  }

  ._box1 {
    width: 100%;
    // height: 38em;
    margin: 0 auto;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;


    ._box-content {
      width: 90%;
      min-height: 0;
      height: auto;
      //justify-content: center;
      //align-items: center;
      //border: 1px solid black;
      margin: 0 auto;
      // margin-top: -5%;
      /*padding-left: 3.5%;*/
      padding: 5% 0;

      ._box-title {
        width: 100%;
        height: 40px;
        font-family: "fzxbsjt";
        font-weight: bold;
        font-size: 18px;
        color: #333333;
        line-height: 40px;
        text-align: left;
        font-style: normal;
        display: flex;
      }

      ._box-title2 {
        width: 100%;
        height: 40px;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: bold;
        font-size: 15px;
        color: #333333;
        line-height: 20px;
        text-align: center;
        font-style: normal;
        display: flex;
        justify-content: center;

      }

      ._box-title2:hover {
        width: 100%;
        height: 40px;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: bold;
        font-size: 15px;
        color: rgba(0, 174, 239, 1);
        line-height: 20px;
        text-align: center;
        font-style: normal;
        display: flex;
        justify-content: center;
        cursor: pointer;
      }

      ._box-line {
        flex: 1;
        height: 0.05cm;
        border-bottom: 1px solid #CCCCCC;
        width: 100%;
        margin-top: 0.2cm
      }

      ._box-row {
        height: 100%;
        width: 100%;
        margin-top: 3em;
      }

      ._box-col {
        height: 100%;
        width: 100%;

        // float: left;
      }

      ._box-divide {
        width: 100%;
        height: 100%;
        padding: 3% 0;
        // border-right: 2px solid #CCCCCC;
      }

      ._box-divide2 {
        width: 100%;
        height: 100%;
        padding: 3% 0;

        // border-right: 2px solid #CCCCCC;
        // padding-right: 4%;cursor: pointer;
      }
    }

  }

  ._pulic {
    width: 100%;
    // height: 75vh;
    background-color: #EBEBEB;
    // background-image: url(../../assets/img/黑底.png);
    background-size: 100% 100%;
    margin-top: 2rem;

    ._box-content {
      margin: 0 auto;
      width: 90%;
      padding: 5% 0 5% 0;
    }

    ._box-title {
      width: 100%;
      height: 40px;
      font-family: "fzxbsjt";
      font-weight: bold;
      font-size: 18px;
      // color: #ffffff;
      line-height: 40px;
      text-align: left;
      font-style: normal;
      display: flex;
    }

    ._box-line {
      flex: 1;
      height: 0.05cm;
      border-bottom: 1px solid #CCCCCC;
      width: 100%;
      margin-top: 0.2cm
    }

    /deep/ .el-carousel__container {
      height: 30vh;
    }

    ._zoomable-background {
      background-position: center;
      transition: transform 0.5s ease; /* 平滑放大效果 */
      cursor: pointer; /* 将鼠标指针改为手指形状 */
      width: 20vh;
      height: 100%;
      background-size: 100% 100%;
      margin: 0 auto
    }

    ._zoomable-background:hover {
      transform: scale(1.1); /* 鼠标悬停时放大1.1倍 */
    }
  }

  ._publication-box {
    height: 30vh;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  ._publication_text {
    width: 100%;
    height: 90%;
    position: relative;
    // color: #fffefe;
  }

  ._publication_title {
    //min-height: 2em;
    //overflow-wrap: break-word;
    // color: rgba(255, 255, 255, 1);
    font-size: 1.8em;
    font-family: "fzxbsjt";
    font-weight: 500;
    text-align: justify;
    //line-height: 1.2em;
    //padding: 0.5em 0;
  }

  ._publication_content {
    min-height: 30%;
    overflow-wrap: break-word;
    // color: rgba(255, 255, 255, 1);
    font-size: 1em;
    font-family: ABCMarfa-Medium;
    font-weight: 400;
    text-align: left;
    line-height: 1.3em;
    padding: 0.6em 0;

  }

  ._publication_date {
    width: 100%;
    text-align: right;
    // color: rgba(255, 255, 255, 1);
    font-size: 1em;
    padding-top: 0.6em

  }

  ._publication_button {
    position: absolute;
    right: 0;
    bottom: 18%;

  }

  // .swiper-pagination-bullet{
  //   width:4px;
  //   height: 4px;
  // }
  ._vision-card1 {
    position: relative;
    width: 100%;
    height: 70%;
    border-radius: 40px;
    //background-color: #FFFFFF;
    padding-top: 20%;
    //border: 3px solid #333333;
    cursor: pointer;
    /* border-radius: 50%; */
    /* background: url(./imgs/img_01.png) 100% no-repeat; */
    /* background-size: 100% 100%; */
  }

  ._vision-card1-img {
    width: 18em;
    height: 18em;
    margin: 3% auto;
    /* border-radius: 50%; */
    /*background: url(./imgs/img_01.png) 100% no-repeat;*/
    background: url(../../assets/home/version3.png) 100% no-repeat;
    background-size: 100% 100%;
  }

  /* .vision-card1:hover {
    background: url(../../assets/home/情报hover.png) 100% no-repeat;
    background-size: 100% 100%;
  } */
  ._vision-card2 {
    position: relative;
    width: 100%;
    height: 70%;
    border-radius: 40px;
    //background-color: #FFFFFF;
    padding-top: 20%;
    //border: 3px solid #333333;
    cursor: pointer;
    /* border-radius: 50%; */
    /* background: url(./imgs/img_01.png) 100% no-repeat; */
    /* background-size: 100% 100%; */
  }

  ._vision-card2-img {
    width: 18em;
    height: 18em;
    margin: 3% auto;
    /* border-radius: 50%; */
    background: url(../../assets/home/version9.png) 100% no-repeat;
    /*background: url(./imgs/img_02.png) 100% no-repeat;*/
    background-size: 100% 100%;
  }


  ._vision-card3 {
    position: relative;
    width: 100%;
    height: 70%;
    border-radius: 40px;
    //background-color: #FFFFFF;
    padding-top: 20%;
    //border: 3px solid #333333;
    cursor: pointer;
    /* border-radius: 50%; */
    /* background: url(./imgs/img_01.png) 100% no-repeat; */
    /* background-size: 100% 100%; */
  }

  ._vision-card3-img {
    width: 18em;
    height: 18em;
    margin: 3% auto;
    /* border-radius: 50%; */
    /*background: url(./imgs/img_03.png) 100% no-repeat;*/
    background: url(../../assets/home/version7.png) 100% no-repeat;
    background-size: 100% 100%;
  }

  ._vision-card4 {
    position: relative;
    width: 100%;
    height: 70%;
    border-radius: 40px;
    //background-color: #FFFFFF;
    padding-top: 20%;
    //border: 3px solid #333333;
    cursor: pointer;
    /* border-radius: 50%; */
    /* background: url(./imgs/img_01.png) 100% no-repeat; */
    /* background-size: 100% 100%; */
  }

  ._vision-card1-img:hover {
    background: url(../../assets/img/鼠标经过有投影.png) 100% no-repeat;
    background-size: 100% 100%;
  }

  ._vision-card2-img:hover {
    background: url(../../assets/img/编组2.png) 100% no-repeat;
    background-size: 100% 100%;
  }

  ._vision-card3-img:hover {
    background: url(../../assets/img/编组8.png) 100% no-repeat;
    background-size: 100% 100%;
  }

  ._vision-card4-img:hover {
    background: url(../../assets/img/编组.png) 100% no-repeat;
    background-size: 100% 100%;
  }

  ._vision-card1:hover {
    color: #3a8ee6;
    animation: pulse; /* referring directly to the animation's @keyframe declaration */
    animation-duration: 1s;
  }

  ._vision-card2:hover {
    color: #e6823a;
    animation: pulse; /* referring directly to the animation's @keyframe declaration */
    animation-duration: 1s;
  }

  ._vision-card3:hover {
    color: #e65a3a;
    animation: pulse; /* referring directly to the animation's @keyframe declaration */
    animation-duration: 1s;
  }

  ._vision-card4:hover {
    color: #08b22a;
    animation: pulse; /* referring directly to the animation's @keyframe declaration */
    animation-duration: 1s;
  }

  ._vision-card4-img {
    width: 18em;
    height: 18em;
    margin: 3% auto;
    /* border-radius: 50%; */
    background: url(../../assets/home/version8.png) 100% no-repeat;
    /*background: url(./imgs/img_04.png) 100% no-repeat;*/
    background-size: 100% 100%;
  }

  /* .vision-card4 {
    position: relative;
    width: 16em;
    height: 16em;
    background-color: #FFFFFF;
    border-radius: 50%;
    overflow: hidden;
    background: url(../../assets/home/应急.png) 100% no-repeat;
    background-size: 100% 100%;
  } */
  /* .vision-card4:hover {
    background: url(../../assets/home/应急hover.png) 100% no-repeat;
    background-size: 100% 100%;
  } */
  ._vision-footer {
    position: absolute;
    //bottom: 0;
    width: 100%;
    /* 调整高度以适合圆形底部，这里可能需要实验以找到最佳值 */
    // height: calc(16em * 0.3); /* 假设你希望高度是圆直径的20% */
    // border-radius: 0 0 50% 50%; /* 尝试给底部添加圆角以匹配圆形 */
    // display: flex; /* 使用flex布局可以更容易地处理内容 */
    //align-items: center; /* 垂直居中内容 */
    margin-top: 4px;
    justify-content: center; /* 水平居中内容 */
    font-size: 10px;
    font-weight: bold;
    font-family: SourceHanSansCN, SourceHanSansCN;
    transition: opacity 0.3s ease; /* 添加过渡效果 */
    opacity: 1; /* 默认显示 */
    overflow: hidden;

    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;

  }

  .vision-card1:hover .vision-footer {
    //opacity: 0; /* 鼠标悬浮时隐藏 */
  }

  .vision-card2:hover .vision-footer {
    //opacity: 0; /* 鼠标悬浮时隐藏 */
  }

  .vision-card3:hover .vision-footer {
    //opacity: 0; /* 鼠标悬浮时隐藏 */
  }

  .vision-card4:hover .vision-footer {
    //opacity: 0; /* 鼠标悬浮时隐藏 */
  }

  ._vision-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(153, 153, 153, 0); /* 初始时完全透明 */
    color: transparent; /* 初始时文本颜色也透明（但这通常不会影响显示，因为文本本身会占据空间） */
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 20px;
    transition: background-color 0.3s ease, color 0.3s ease; /* 添加过渡效果到颜色和背景 */
    pointer-events: none; /* 防止覆盖层干扰下方的点击事件（如果需要的话） */
    border-radius: 30px;
  }

  ._box-title2 {
    width: 100%;
    height: 40px;

    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 28px;
    color: #333333;
    line-height: 53px;
    text-align: center;
    font-style: normal;
    display: flex;
    justify-content: center;
  }

  ._box-title2:hover {
    width: 100%;
    height: 40px;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 28px;
    color: rgba(0, 174, 239, 1);
    line-height: 53px;
    text-align: center;
    font-style: normal;
    display: flex;
    justify-content: center;
    cursor: pointer;
  }

}

// =============== 地图模块样式（独立定义，不在媒体查询内） ===============
// 地图容器高度 - PC端
.crime-map-content-pc {
  height: 57em !important;
}

// 地图容器高度 - 移动端
.crime-map-content-mobile {
  height: auto !important;
  min-height: 500px !important;
  padding-bottom: 2em !important;
}

// PC端 Tableau 容器样式
.tableau-container-pc {
  width: 134% !important;
  height: 800px !important;
  margin-top: 2em !important;
  margin-left: -17% !important;
  position: relative;
  overflow: hidden;
}

.tableau-iframe-pc {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: scale(0.8);
  transform-origin: top center;
}

// 移动端 Tableau 容器样式
.tableau-container-mobile {
  width: 100% !important;
  height: 500px !important;
  margin-top: 1em !important;
  margin-left: 0 !important;
  position: relative;
  overflow: hidden;
}

.tableau-iframe-mobile {
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transform: scale(1);
  transform-origin: top left;
}

// 针对小屏手机的优化
@media only screen and (max-width: 640px) {
  .crime-map-content-mobile {
    min-height: 400px !important;
  }

  .tableau-container-mobile {
    height: 400px !important;
  }
}

// 超小屏幕优化
@media only screen and (max-width: 375px) {
  .crime-map-content-mobile {
    min-height: 350px !important;
  }

  .tableau-container-mobile {
    height: 350px !important;
  }
}

/* 热点关注网格布局样式 */
.highlights-grid-container {
  width: 100%;
  padding: 2em 0;
}

.highlights-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 1.5em;
  width: 100%;
  height: 100%;
}

.highlight-card {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 280px;
}

.highlight-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.card-header {
  padding: 1em 1.2em 0.5em;
  background: #f8f9fa;
}

.card-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin: 0 0 0.5em 0;
  font-family: "fzxbsjt", sans-serif;
}

.card-divider {
  height: 2px;
  background: linear-gradient(to right, #00AEF0, #e9ecef);
  border-radius: 1px;
}

.card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.card-image {
  flex: 1;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 140px;
}

.card-text {
  padding: 1em 1.2em;
  background: #ffffff;
}

.card-description {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 移动端适配 */
@media only screen and (max-width: 800px) {
  .highlights-grid-container.mobile {
    padding: 1em 0;
  }

  .highlights-grid.mobile {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 1em;
  }

  .highlight-card.mobile {
    height: 200px;
  }

  .card-header.mobile {
    padding: 0.8em 1em 0.4em;
  }

  .card-title.mobile {
    font-size: 14px;
  }

  .card-image.mobile {
    min-height: 100px;
  }

  .card-text.mobile {
    padding: 0.8em 1em;
  }

  .card-description.mobile {
    font-size: 12px;
    -webkit-line-clamp: 2;
    line-clamp: 2;
  }
}

</style>

<style scoped>
:deep(.el-tabs--border-card > .el-tabs__header .el-tabs__item:nth-child(1).is-active) {
  background-color: #F3F5FC;
  border-radius: 0px 23px 0px 0px;
  box-shadow: 20px 0px 20px rgba(0, 0, 0, 0.3);
}

:deep(.el-tabs--border-card > .el-tabs__header .el-tabs__item:nth-child(1)) {
  background-color: #F3F5FC;
}

:deep(.el-tabs--border-card > .el-tabs__header .el-tabs__item:nth-child(2).is-active) {
  background-color: #FCF3FB;
  border-radius: 0px 23px 0px 0px;
  box-shadow: 20px 0px 20px rgba(0, 0, 0, 0.3);
}

:deep(.el-tabs--border-card > .el-tabs__header .el-tabs__item:nth-child(2)) {
  background-color: #FCF3FB;
}

:deep(.el-tabs--border-card > .el-tabs__header .el-tabs__item:nth-child(3).is-active) {
  background-color: #F3FCF4;
  border-radius: 0px 23px 0px 0px;
  box-shadow: 20px 0px 20px rgba(0, 0, 0, 0.3);
}

:deep(.el-tabs--border-card > .el-tabs__header .el-tabs__item:nth-child(3)) {
  background-color: #F3FCF4;
}

:deep(.el-tabs--border-card > .el-tabs__header .el-tabs__item:nth-child(4).is-active) {
  background-color: #FCF8F3;
  border-radius: 0px 23px 0px 0px;
  box-shadow: 20px 0px 20px rgba(0, 0, 0, 0.3);
}

:deep(.el-tabs--border-card > .el-tabs__header .el-tabs__item:nth-child(4)) {
  background-color: #FCF8F3;

}

:deep(.el-tabs--border-card > .el-tabs__content) {
  padding: 0px;
}

:deep(.el-tabs__content #pane-0) {
  background-color: #F3F5FC;
}

:deep(.el-tabs__content #pane-1) {
  background-color: #FCF3FB;
}

:deep(.el-tabs__content #pane-2) {
  background-color: #F3FCF4;
}

:deep(.el-tabs__content #pane-3) {
  background-color: #FCF8F3;
}

:deep(.el-tabs--border-card) {
  background: #FFF;
  border: 1px solid rgba(220, 223, 230, 0.52);
  -webkit-box-shadow: 0 0px 0px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
  box-shadow: 0 0px 0px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
}


.flex-row {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.justify-between {
  display: flex;
  justify-content: space-between;
}

.image-text_12 {
  width: 116px;
  height: 130px;
}

.group_13 {
  background-image: url(../../assets/img/c9c8552c1dfe4d078183b327cc4d3d6e_mergeImage.png);
  width: 80px;
  height: 80px;
  margin-left: 18px;
}

.text-group_7 {
  width: 100%;
  height: 36px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 12px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: center;
  line-height: 18px;
  margin-top: 14px;
}

.image-text_13 {
  width: 125px;
  height: 130px;
}

.section_3 {
  background-image: url(../../assets/img/f0ee0a42c42a4b13b5f77ada2078c168_mergeImage.png);
  width: 80px;
  height: 80px;
  margin-left: 22px;
}

.text-group_8 {
  width: 100%;
  height: 36px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 12px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: center;
  line-height: 18px;
  margin-top: 14px;
}

.image-text_14 {
  width: 121px;
  height: 148px;
}

.section_4 {
  background-image: url(../../assets/img/e01c27a55698476e95998d41fcc9dc81_mergeImage.png);
  width: 80px;
  height: 80px;
  margin-left: 20px;
}

.text-group_9 {
  width: 100%;
  height: 54px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 12px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: center;
  line-height: 18px;
  margin-top: 14px;
}

.image-text_15 {
  width: 128px;
  height: 130px;
}

.section_5 {
  background-image: url(../../assets/img/1224cb5b5d274d67825f5f861b764e5a_mergeImage.png);
  width: 80px;
  height: 80px;
  margin-left: 24px;
}

.text-group_10 {
  width: 100%;
  height: 36px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 12px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: center;
  line-height: 18px;
  margin-top: 14px;
}

.image-text_16 {
  width: 113px;
  height: 130px;
}

.group_14 {
  background-image: url(../../assets/img/e8d90c7875b043f984bc79a60f0a737e_mergeImage.png);
  width: 80px;
  height: 80px;
  margin-left: 16px;
}

.text-group_11 {
  width: 100%;
  height: 36px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 12px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: center;
  line-height: 18px;
  margin-top: 14px;
}

.image-text_17 {
  width: 127px;
  height: 130px;
}

.group_15 {
  background-image: url(../../assets/img/e136d12a899545719e9e166bb479550c_mergeImage.png);
  width: 80px;
  height: 80px;
  margin-left: 24px;
}

.text-group_12 {
  width: 100%;
  height: 36px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 12px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: center;
  line-height: 18px;
  margin-top: 14px;
}

.image-text_18 {
  width: 112px;
  height: 112px;
}

.section_6 {
  background-image: url(../../assets/img/4990ed298fe8415aa28d442bcf13f62a_mergeImage.png);
  width: 80px;
  height: 80px;
  margin-left: 16px;
}

.text-group_13 {
  width: 100%;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 12px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin-top: 14px;
}

.image-text_19 {
  width: 98px;
  height: 166px;
}

.section_7 {
  background-image: url(../../assets/img/acc49351fca84aecb82b8e8f2d4d4d90_mergeImage.png);
  width: 80px;
  height: 80px;
  margin-left: 9px;
}

.text-group_14 {
  width: 100%;
  height: 72px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 12px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: center;
  line-height: 18px;
  margin-top: 14px;
}

.image-text_20 {
  width: 105px;
  height: 130px;
}

.block_6 {
  background-image: url(../../assets/img/8594b178db15434297df9447066d0d68_mergeImage.png);
  width: 80px;
  height: 80px;
  margin-left: 12px;
}

.text-group_15 {
  width: 100%;
  height: 36px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 12px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: center;
  line-height: 18px;
  margin-top: 14px;
}

.image-text_21 {
  width: 80px;
  height: 112px;
}

.section_8 {
  background-image: url(../../assets/img/650e38292d7648e8969bec341d7e595e_mergeImage.png);
  width: 80px;
  height: 80px;
}

.text-group_16 {
  width: 100%;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 12px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin: 14px 0 0 4px;
}


.group_24 {
  width: 75vw;
  height: 13.34vw;
  margin-left: 2em;
}

.group_10 {
  box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.1);
  height: 13.34vw;
  width: 13.34vw;
  border-radius: 1em;
}

.section_2 {
  height: 13.34vw;
  overflow: hidden;
  background: url(../../assets/img/SketchPng7b3e824d451f87ae65321861a6387603107e43562a3cd8fd9155de120d125136.png) -2.09vw -2.09vw no-repeat;
  background-size: 17.5vw 17.5vw;
  width: 13.34vw;
  position: relative;
  border-radius: 1em;
}

.paragraph_1 {
  width: 9.65vw;
  height: 2.09vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.83vw;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: justify;
  line-height: 1.05vw;
  margin: 2.55vw 0 0 1.04vw;

}

.block_4 {
  position: absolute;
  left: -3.07vw;
  top: 6.1vw;
  width: 12.24vw;
  height: 11.57vw;
  background: url(../../assets/img/7ca24eac48124eb388ceeff6a0b57be4_mergeImage.png) 100% no-repeat;
  background-size: 100% 100%;

}

.text-group_18 {
  width: 9.38vw;
  height: 1.98vw;
  margin: 4.21vw 0 0 4.11vw;

}

.text_21 {
  width: 9.38vw;
  height: 0.73vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.72vw;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: justify;
  white-space: nowrap;
  line-height: 1.1vw;

}

.text_22 {
  width: 3.86vw;
  height: 0.73vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.72vw;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: justify;
  white-space: nowrap;
  line-height: 1.1vw;
  margin-top: 0.53vw;
}

.text-group_19 {
  position: absolute;
  left: 4.12vw;
  top: 4.22vw;
  width: 9.38vw;
  height: 1.98vw;

}

.image_4 {
  position: absolute;
  left: 6.31vw;
  top: 1.31vw;
  width: 6.41vw;
  height: 5.84vw;
}

.list_4 {
  width: 75vw;
  height: 15vw;
  justify-content: space-between;

}

.list-items_1 {
  height: 15vw;
  overflow: hidden;
  background-size: 100% 100%;
  margin-right: 2.09vw;
  width: 13.34vw;
  position: relative;
  border-radius: 1em;
  cursor: pointer;
}

.text_23 {
  width: 9.65vw;
  height: 2.09vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.83vw;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: justify;
  line-height: 1.05vw;
  margin: 2.55vw 0 0 1.04vw;
}

.block_5 {
  position: absolute;
  left: -3.07vw;
  top: 6.1vw;
  width: 12.24vw;
  height: 11.57vw;
  background-size: 100% 100%;
}

.text-group_20 {
  width: 9.33vw;
  height: 1.98vw;
  margin: 4.21vw 0 0 4.11vw;
}

.text_24 {
  width: 9.38vw;
  height: 0.73vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.72vw;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: justify;
  white-space: nowrap;
  line-height: 1.1vw;
}

.text_25 {
  width: 3.86vw;
  height: 0.73vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.72vw;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: justify;
  white-space: nowrap;
  line-height: 1.1vw;
  margin-top: 0.53vw;
}

.text-group_21 {
  position: absolute;
  left: 4.12vw;
  top: 4.22vw;
  width: 9.33vw;
  height: 1.98vw;
}

.image_5 {
  position: absolute;
  left: 6.31vw;
  top: 1.31vw;
  width: 6.41vw;
  height: 5.84vw;
}


:deep(.el-carousel__indicators--outside) {
  margin-top: 2em;
}

:deep(.el-carousel__indicators--outside button) {
  background-color: #294f9c;
}


.mySwiper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.15);
  position: relative;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 80%;
  object-fit: cover;
}

.swiper_img {
  width: 100%;
  height: 85%;
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 不重复 */
  background-size: 100% 100%; /* 覆盖整个div，但可能裁剪图片 */
}


.swiper_text {
  font-size: 1.8vh;
  text-align: left;
  padding-left: 3%;
  margin-top: 1em;
  width: 90%;
  text-overflow: ellipsis;
  white-space: nowrap; /* 确保文本不换行 */
  overflow: hidden; /* 隐藏超出容器的内容 */
  text-overflow: ellipsis; /* 使用省略号显示被截断的文本 */
  line-height: 1.4em;
}

.swiper_date {
  position: absolute;
  right: 4%;
  top: 30%;
  font-size: 1.6vh;
}

/* 调整指示器的大小 */
::v-deep el-carousel__button {
  width: 1.2em; /* 设置宽度 */
}

.swiper-pagination {
  position: absolute;
  width: 100%;
  bottom: 21% !important;
}


</style>



// WEBPACK FOOTER //
// src/components/Home/Home2.vue